import Constants from '../config/const';
import { uploadPreview, saveWall } from './save_wall';
import { publishWallApi } from '../config/api';

export const publish = () => (dispatch, getState) => {
  dispatch({ type: Constants.export.publishing });
  const { canvas: { wallId } } = getState();
  publishWallApi(wallId).then(() => {
    dispatch({ type: Constants.export.published });
  });
};

export const savePreview = (src, transparentSrc, previewTimeStamp) => (dispatch, getState) => {
  const {
    previewTimeStamp: lastPreviewTimeStamp,
    previewSrc
  } = getState().exporting;
  if (previewTimeStamp === lastPreviewTimeStamp) {
    dispatch({
      type: Constants.export.previewSaved,
      previewTimeStamp,
      previewSrc
    });
    return;
  }
  dispatch({ type: Constants.export.savePreview });
  uploadPreview(getState, src, transparentSrc).then(([newSrc, newTransparentSrc]) => {
    const complete = new Promise((res, rej) => {
      dispatch(saveWall(newSrc, newTransparentSrc, res, rej));
    });
    complete.then(() => {
      dispatch({
        type: Constants.export.previewSaved,
        previewTimeStamp,
        previewSrc: newSrc
      });
    });
  }).catch((error) => {
    dispatch({
      type: Constants.export.previewSaved,
      error
    });
  });
};

export const showSharing = () => ({
  type: Constants.export.showSharing
});

export const setLogo = (logoSrc) => ({
  type: Constants.export.setLogo,
  logoSrc
});

export const resetLogo = () => ({
  type: Constants.export.setLogo,
  logoSrc: null
});

// export const publish = (src, previewTimeStamp) => (
//   dispatch, getState
// ) => savePreviewAndSaveWall(src, previewTimeStamp, dispatch, getState).then(() => {
//   // TODO
// });
